import React, {useState, useEffect, useRef} from 'react';
import {getCustomerList, syncCustomer} from '@/api/customer';
import {PageGrid} from '@/component';
import {PageHeader, Button, Input, Select, message, Spin} from 'antd';
import {TwoColumnLayout} from '@/component';
import {SyncOutlined, TagOutlined} from '@/icons';
import styles from '../index.module.less';
import {useAuthStore} from '@/context/auth';
import _ from 'lodash';
import {getColumns} from '@/page/customer/CustomPage/customerColumns';
import TagModal from '@/page/customer/CustomPage/TagModal';
import {useEditAuthService} from '@/page/admin/adminService';
import tag from '@/page/component/UEditor/ifanrx-react-ueditor/Tag';
import Item from '@/page/app/MsgSendPage/Item';
import CreateExcel from 'js-export-excel';
import dayjs from 'dayjs';

const {Option} = Select;

function CustomPage() {
    const editable = useEditAuthService(['global:customer_mgr:w']);
    const tagRef = useRef();
    const tableRef = useRef();
    const [authStore] = useAuthStore();
    const userId = _.get(authStore, 'user.extId');
    const [url, setUrl] = useState(null);
    const [loading, setLoading] = useState(false);
    const [searchParam, setSearchParam] = useState({
        name: '',
        follow: '',
        type: 0,
        userId: userId,
    });

    const extra = (
        <Input.Group compact>
            <Input
                className={styles.baseSearch}
                placeholder="请输入客户名称"
                onChange={changeName}
            />
            <Input
                className={styles.baseSearch}
                placeholder="请输入跟进员工编号或名称"
                onChange={changeFollow}
            />
            <Select defaultValue="0" className={styles.baseSelect} onChange={changeSelect}>
                <Option value="0">全部</Option>
                <Option value="1">微信客户</Option>
                <Option value="2">企业微信客户</Option>
            </Select>
            <Button type="primary" style={{marginLeft: '10px'}} onClick={search}>
                查询
            </Button>
            {/*<Button*/}
            {/*    disabled={!editable}*/}
            {/*    type="primary"*/}
            {/*    icon={<SyncOutlined />}*/}
            {/*    style={{marginLeft: '10px'}}*/}
            {/*    onClick={sync}*/}
            {/*>*/}
            {/*    同步*/}
            {/*</Button>*/}
            <Button
                disabled={!editable}
                type="primary"
                style={{marginLeft: '10px'}}
                onClick={exportExcel}
            >
                导出
            </Button>
        </Input.Group>
    );
    let columns = getColumns();
    columns.push({
        title: '操作',
        dataIndex: 'action',
        align: 'center',
        render: (text, record) => (
            <Button
                disabled={!editable}
                type="text"
                onClick={() => edit(record)}
                icon={<TagOutlined />}
                style={{color: '#152D85'}}
            >
                添加标签
            </Button>
        ),
    });
    useEffect(() => {
        setUrl('/customer/list');
    }, []);

    function changeName(e) {
        let temp = {...searchParam};
        temp.name = e.target.value;
        setSearchParam(temp);
    }

    function changeFollow(e) {
        let temp = {...searchParam};
        temp.follow = e.target.value;
        setSearchParam(temp);
    }

    function changeSelect(e) {
        let temp = {...searchParam};
        temp.type = parseInt(e, 10);
        setSearchParam(temp);
    }

    function search() {
        const {name, type, userId, follow} = searchParam;
        setUrl(
            `/customer/list?name=${encodeURIComponent(name)}&type=${encodeURIComponent(
                type
            )}&userId=${encodeURIComponent(userId)}&follow=${encodeURIComponent(follow)}`
        );
    }

    function sync() {
        setLoading(true);
        syncCustomer(userId).then(res => {
            setLoading(false);
            message.success('同步成功');
            search();
        });
    }

    function exportExcel() {
        setLoading(true);
        let params = {...searchParam};
        params.current = 1;
        params.size = 99999;
        getCustomerList(params).then(res => {
            console.log(res);
            if (res.data.records.length > 0) {
                let {records} = res.data;
                let option = {
                    fileName: '客户列表',
                };
                let dataTable = [];
                records.forEach(item => {
                    let {tagLinks, customerName, realName, gender, type, userName, extId, depName, hospitalName, externalUserid, createtime} = item;
                    let tags = '';
                    if (tagLinks.length > 0) {
                        tagLinks.forEach(tag => {
                            tags = tags + ',' + tag.tagName;
                        });
                    }
                    if (tags !== '') tags = tags.substring(1, tags.length);
                    let data = {
                        客户: customerName,
                        客户实名: realName || '未实名',
                        科室: depName,
                        医院: hospitalName,
                        跟进员工: `${userName}(${extId})`,
                        跟进时间: dayjs(createtime*1000).format('YYYY-MM-DD HH:mm:ss'),
                        客户性别: gender == 0 ? '未知' : gender == 1 ? '男' : '女',
                        客户类型: type == 0 ? '' : type == 1 ? '微信客户' : '企业成员',
                        externalUserId: externalUserid,
                        标签: tags,
                    };
                    dataTable.push(data);
                });
                option.datas = [
                    {
                        sheetData: dataTable,
                        sheetName: 'sheet',
                        sheetFilter: [
                            '客户',
                            '客户实名',
                            '跟进员工',
                            '跟进时间',
                            '科室',
                            '医院',
                            '客户性别',
                            '客户类型',
                            'externalUserId',
                            '标签',
                        ],
                        sheetHeader: [
                            '客户',
                            '客户实名',
                            '跟进员工',
                            '跟进时间',
                            '科室',
                            '医院',
                            '客户性别',
                            '客户类型',
                            'externalUserId',
                            '标签',
                        ],
                    },
                ];
                let toExcel = new CreateExcel(option);
                toExcel.saveExcel();
                setLoading(false);
            } else {
                message.info('无数据导出');
                setLoading(false);
            }
        });
    }

    function edit(record) {
        tagRef.current.open(record.id);
    }

    function reload() {
        tableRef.current.refresh();
    }

    return (
        <TwoColumnLayout>
            <TwoColumnLayout.ContentPanel>
                <div className={styles.header}>
                    <PageHeader title="客户列表" extra={extra} />
                </div>
                <Spin spinning={loading}>
                    <div className={styles.tableContainer}>
                        {searchParam && url && (
                            <PageGrid
                                url={url}
                                columns={columns}
                                initParams={searchParam}
                                ref={tableRef}
                            />
                        )}
                        <TagModal ref={tagRef} reload={reload} />
                    </div>
                </Spin>
            </TwoColumnLayout.ContentPanel>
        </TwoColumnLayout>
    );
}

export default CustomPage;
